module.exports = __webpack_public_path__ + "img/flight-deck-gal-3.6f42cce6.jpg";